import { Alert as MUIAlert, SxProps } from '@mui/material';
import React from 'react';
import { CheckCircle, Report, ReportProblem } from '@mui/icons-material';

import palette from '../../../../styles/themes/palette';

type Props = {
  severity: 'error' | 'warning' | 'info' | 'success';
  children: React.ReactNode;
  sx?: SxProps;
  size?: 'medium' | 'small';
};

export const Alert = ({ severity, children, sx, size = 'medium' }: Props) => {
  let colorPalette = palette.error;
  let icon = <Report style={{ transform: 'rotate(180deg)' }} />;
  switch (severity) {
    case 'warning':
      colorPalette = palette.warning;
      icon = <ReportProblem />;
      break;
    case 'success':
      colorPalette = palette.success;
      icon = <CheckCircle />;
      break;
    case 'error':
    default:
      colorPalette = palette.error;
      icon = <Report style={{ transform: 'rotate(180deg)' }} />;
      break;
  }

  const isSmall = size === 'small';
  const iconColumnWidth = isSmall ? '24px' : '32px';
  const iconSize = isSmall ? 16 : 20;
  const paddingTop = isSmall ? 0.75 : 1;
  const paddingRight = isSmall ? 0.75 : 1;
  const paddingLeft = isSmall ? 0.75 : 1;
  const borderRadius = isSmall ? '6px' : '8px';

  return (
    <MUIAlert
      severity={severity}
      sx={{
        background: `linear-gradient(90deg, ${colorPalette.main} ${iconColumnWidth}, ${colorPalette.light} 0)`,
        gridTemplateColumns: `${iconColumnWidth} 1fr`,
        border: '1px solid',
        borderColor: colorPalette.main,
        borderRadius,
        color: colorPalette.dark,
        display: 'grid',
        pl: 0,
        pt: paddingTop,
        pr: paddingRight,
        fontSize: isSmall ? '12px' : undefined,
        '& .MuiAlert-icon': {
          '& svg': {
            fontSize: iconSize,
          },
          color: colorPalette.contrastText,
          m: 0,
          justifyContent: 'center',
        },
        '& .MuiAlert-message': {
          pl: paddingLeft,
        },
        ...sx,
      }}
      icon={icon}
    >
      {children}
    </MUIAlert>
  );
};
